import { Routes, Route, Navigate } from "react-router-dom";
import AlertHandler from "./components/alerts/AlertHandler";
import Layout from "./components/Layout";
import Login from "./features/auth/Login";
import PersistLogin from "./components/PersistLogin";
// import InvitationHandler from "./components/InvitationHandler";
// import AuthorizedRoute from "./components/AutorizedRoute";
import Cognito from "./features/auth/Cognito";
// import { userActions } from "./config/accessConfig";
// import { PageNotFound } from "./features/auth/NotFound";
import NotFoundHandler from "./components/NotFountHandler";
import EmployeeList from "./features/employees/EmployeeList";
import EmployeePage from "./features/employees/EmployeePage";
import ConfigurationsList from "./features/configurations/ConfigurationsList";
import ConfigurationPage from "./features/configurations/ConfigurationPage";
import { pathnames } from "./config/routes";
import { userActions } from "./config/accessConfig";
import AccessWrapper from "./features/auth/AccessWrapper";

const App = () => {
  return (
    <>
      <Routes>
        <Route element={<AlertHandler />}>
          <Route path="cognito" element={<Cognito />} />
          <Route path="login" element={<Login />} />
          <Route element={<PersistLogin />}>
            <Route element={<Layout />}>
              <Route path={pathnames.CONFIGURATIONS}>
                <Route
                  index
                  element={
                    <AccessWrapper action={userActions.SHOW_CONFIGURATIONS}>
                      <ConfigurationsList />
                    </AccessWrapper>
                  }
                />
                <Route
                  path=":configurationId"
                  element={
                    <AccessWrapper action={userActions.SHOW_CONFIGURATIONS}>
                      <ConfigurationPage />
                    </AccessWrapper>
                  }
                />
              </Route>
              <Route path={pathnames.EMPLOYEES}>
                <Route
                  index
                  element={
                    <AccessWrapper action={userActions.SHOW_EMPLOYEES}>
                      <EmployeeList />
                    </AccessWrapper>
                  }
                />
                <Route
                  path=":employeeId"
                  element={
                    <AccessWrapper action={userActions.SHOW_EMPLOYEES}>
                      <EmployeePage />
                    </AccessWrapper>
                  }
                />
              </Route>
              <Route element={<NotFoundHandler />}></Route>
              <Route
                index
                element={<Navigate to={pathnames.CONFIGURATIONS} replace />}
              />
              <Route
                path="*"
                element={<Navigate to={pathnames.CONFIGURATIONS} replace />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
